// Auto-generated by splitter.py — do not regenerate; edit directly.

/**
 * WHAT KIND OF PLACE THIS IS — ONE vocabulary, and it is the database's.
 *
 * `Venue.venueType` is a Postgres enum (`enum_Venue_venueType`). The console used to hold
 * THREE different lists for it and none of them could reach the column:
 *   · this file's old display names ('Open Grounds', 'School Field', 'Resort') — not enum
 *     labels, so the venue list's "All types" filter compared them against stored values
 *     they can never equal. A filter that could only ever return nothing.
 *   · SeatingWizard's own slugs ('theatre', 'conference', 'outdoor', 'club') — 4 of its 8
 *     options are not enum labels, so sending them would 400. Someone worked around that by
 *     stashing the type in the free-form `metadata` jsonb instead, which is why `venueType`
 *     is NULL on every venue and the list's TYPE column reads "Venue —" for all of them.
 *   · the enum itself, which is the only one Postgres will accept.
 *
 * So: the enum IS the list. A type an operator can pick is a type that can be stored, and a
 * type that is stored is a type they can filter by. Labels are display only — `value` is what
 * travels. Adding a kind means adding the enum label first; the picker follows the column.
 */
export const VENUE_TYPES = [
  { value: 'stadium', label: 'Stadium' },
  { value: 'arena', label: 'Arena' },
  { value: 'amphitheater', label: 'Amphitheatre' },
  { value: 'outdoor_venue', label: 'Outdoor venue' },
  { value: 'theater', label: 'Theatre' },
  { value: 'cinema', label: 'Cinema' },
  { value: 'concert_hall', label: 'Concert hall' },
  { value: 'conference_center', label: 'Conference centre' },
  { value: 'nightclub', label: 'Nightclub' },
  { value: 'banquet_hall', label: 'Banquet hall' },
  { value: 'restaurant', label: 'Restaurant' },
  { value: 'other', label: 'Other' },
];

/** The enum label read in words. An unknown/absent value stays absent — never guessed. */
export const venueTypeLabel = (value) =>
  VENUE_TYPES.find((t) => t.value === value)?.label || null;

/**
 * A venue built in Quick Setup has its own, more precise type (VenueModel.typeId): a bar is stored as
 * `nightclub` in the Venue column, but it is a bar. Labels as Quick Setup names them.
 */
const MODEL_TYPE_LABELS = {
  stadium: 'Stadium', arena: 'Arena', dome: 'Dome', theatre: 'Theatre', auditorium: 'Auditorium', cinema: 'Cinema',
  bar: 'Bar', club: 'Club', restaurant: 'Restaurant', exhibition: 'Exhibition hall', convention: 'Convention centre',
  conference: 'Conference venue', festival: 'Outdoor / festival', multi: 'Multi-purpose', blank: 'Custom / blank',
};
export const venueModelTypeLabel = (id) => MODEL_TYPE_LABELS[id] || null;
/** The types a venue can open as in the venue model (adopting an existing venue picks one). */
export const VENUE_MODEL_TYPES = Object.entries(MODEL_TYPE_LABELS).map(([value, label]) => ({ value, label }));

/** Which kinds are under a roof. Derived from the kind — the Venue table has no indoor column. */
const INDOOR_TYPES = new Set(['arena', 'theater', 'cinema', 'concert_hall', 'conference_center', 'nightclub', 'banquet_hall', 'restaurant']);
export const venueTypeIsIndoor = (value) => INDOOR_TYPES.has(value);

export const GATE_TYPES = ['Outdoor gate','Indoor gate','VIP gate','Service gate','Emergency gate'];

export const ROW_NOMENCLATURES = ['A-Z (alphabetic)','AA-ZZ (extended alphabetic)','1-N (numeric)','Custom'];

export const SEAT_DIRECTIONS = ['Left-to-right','Right-to-left','Center-outward'];

/* ============================================================================
   TOURNAMENTS RICH — for the rebuilt module
   ============================================================================ */

